import { Component } from "react";

import type { IComponent } from "../Component";
import { defaultAttributes } from "../Component";

import * as css from "./IconBase.module.css";

export interface IIconBase extends IComponent {
    iconAppearance?: "DarkBlue" | "Green" | "Gray" | "LightBlue" | "LightGray" | "Magenta" | "None" | "White";
}

export abstract class IconBase<TProps extends IIconBase = IIconBase> extends Component<TProps> {
    protected abstract get icon(): JSX.Element;

    private get iconAppearance(): string {
        switch (this.props.iconAppearance) {
            case "None":
                return css.none;
            case "Magenta":
                return css.magenta;
            case "White":
                return css.white;
            case "Gray":
                return css.gray;
            case "LightGray":
                return css.lightGray;
            case "LightBlue":
                return css.lightBlue;
            case "Green":
                return css.green;
            case "DarkBlue":
            default:
                return css.darkBlue;
        }
    }

    protected isPureComponent = true;

    protected abstract cssClassName: string | null;

    public render() {
        return (
            <div
                {...defaultAttributes(
                    this.props,
                    css.iconBaseComponent,
                    this.cssClassName,
                    this.iconAppearance,
                )}
            >
                {this.icon}
            </div>
        );
    }
}
